var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"extraLarge":"","title":"Atribuição de cota de exame"},scopedSlots:_vm._u([{key:"footer",fn:function({ cancel }){return [_c('rkm-button',{on:{"click":cancel}},[_vm._v(" Fechar ")])]}}])},[_c('Form',{ref:"Form",attrs:{"data":_vm.data,"item":_vm.item,"indexExame":_vm.indexExame},on:{"save":_vm.handleExit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }